// Last JS update: 2026-01-25 16:00
function formatMoney(amount) {
	const moneyFormat = document.getElementById("ProductGridContainer")?.getAttribute("data-money-format");
	return moneyFormat?.replace(/\{\{\s*amount\s*\}\}/, (amount / 100).toFixed(2)) || amount;
}

// Arrow states are now handled by CSS hover, no JavaScript needed

window.createSlider = function(glideElement) {
	// Check if Glide library is available
	if (typeof Glide === 'undefined') {
		return;
	}
	
	// Creating slider with Glide.js
	
	// Prevent double initialization
	if (glideElement.glideInstance) {
		glideElement.glideInstance.destroy();
		glideElement.glideInstance = null;
	}
	
	const slides = glideElement.querySelectorAll(".glide__slide");

	if (slides.length === 1) {
		glideElement.classList.add("one-slide");
		return;
	}

	// Remove one-slide class if multiple slides
	glideElement.classList.remove("one-slide");

	try {
		const glide = new Glide(glideElement, {
			type: "slider",
			perView: 1,
			startAt: 0,
			direction: "rtl",
			animationDuration: 300,
			animationTimingFunc: 'ease-out',
			keyboard: false // Disable keyboard navigation
		});
		
		glide.mount();
		glideElement.glideInstance = glide;
		
		// Glide slider mounted successfully
		
		// Arrow states are now handled by CSS hover
		
		// Bind the arrows once per element, synchronously. createSlider runs again on
		// every colour change; deferring this to a frame left the arrows dead in
		// between, and re-cloning them each time threw away a working binding.
		if (!glideElement.dataset.arrowsBound) {
			glideElement.dataset.arrowsBound = 'true';

			[['.glide__arrow--right', '>'], ['.glide__arrow--left', '<']].forEach(([selector, direction]) => {
				const arrow = glideElement.querySelector(selector);
				if (!arrow) return;

				arrow.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					e.stopImmediatePropagation();
					// Read the instance at click time - it is replaced on every re-mount.
					if (glideElement.glideInstance) {
						glideElement.glideInstance.go(direction);
					}
				}, true); // Use capture phase

				arrow.addEventListener('mousedown', (e) => {
					e.preventDefault();
					e.stopPropagation();
				}, true);
			});
		}


	} catch (error) {
		console.error('Error creating slider:', error);
	}
};

// Slides past the first sit outside the viewport horizontally, so the browser
// never lazy-loads them and arrow navigation would show an empty slide while the
// image fetches. Once a card scrolls into view, load the rest of its slides.
const sliderSlidesObserver = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
		if (!entry.isIntersecting) return;
		entry.target.querySelectorAll('img[loading="lazy"]').forEach(img => {
			img.loading = 'eager';
		});
		observer.unobserve(entry.target);
	});
}, { rootMargin: '200px' });

function initProductSlider() {

	const sliders = document.querySelectorAll(".product-card-slider:not([data-initialized])");

	sliders.forEach((slider, index) => {
		
		// Check if already initialized by looking for glideInstance property
		if (slider.glideInstance) {
			return;
		}
		
		// Check if already initialized by main slider (has glide classes)
		if (slider.classList.contains('glide--swipeable') || slider.querySelector('.glide__slide--clone')) {
			return;
		}
		
		// Check if already initialized by iwebsite-glide-slider
		if (slider.classList.contains('glide--disabled') || slider.classList.contains('glide--mounted')) {
			return;
		}
		
		// Check if this is in related products section
		const isInRelatedProducts = slider.closest('.related-products') !== null;
		
		// Initialize all sliders, including related products

		const slides = slider.querySelectorAll(".glide__slide");

		if (slides.length > 1) {
			createSlider(slider);
		} else {
			slider.classList.add('single-image');
		}
		
		// Mark as initialized
		slider.setAttribute('data-initialized', 'true');
	});
}

// Kept separate from initProductSlider on purpose: that function bails early for
// sliders another script already mounted, and an unobserved slider would leave
// its lazy slides permanently blank.
function observeSliderSlides() {
	document.querySelectorAll('.product-card-slider:not([data-slides-observed])').forEach(slider => {
		slider.setAttribute('data-slides-observed', 'true');
		sliderSlidesObserver.observe(slider);
	});
}

// Safety net: if the observer never fired for a card (script error, an observer
// that was never attached), load whatever is still pending once the page settles
// rather than leaving empty slides on screen.
window.addEventListener('load', () => {
	document.querySelectorAll('.product-card-slider img[loading="lazy"]').forEach(img => {
		img.loading = 'eager';
	});
});

// Export to window for use by infinite scroll
window.initProductSlider = initProductSlider;
window.observeSliderSlides = observeSliderSlides;

function initVariantOptions() {
	
	const variantSelects = document.querySelectorAll("variant-selects:not([data-initialized])");
	
	variantSelects.forEach((variantSelect, index) => {
		// SAFEGUARD: do not process main PDP variant selects
		const isInsideProductInfo = !!variantSelect.closest('product-info');
		const isInsideCardsOrRelated = !!variantSelect.closest('product-recommendations, .related-products, quick-order-list, .product-card, .card-wrapper');
		if (isInsideProductInfo && !isInsideCardsOrRelated) return;

		const productId = variantSelect.getAttribute("data-product-id");
		if (!productId) return;
		
		// Get product data
		const productVariantsDiv = document.querySelector(`.product-variants-data[data-product-id='${productId}']`);
		if (!productVariantsDiv) return;
		
		let productData;
		try {
			productData = JSON.parse(productVariantsDiv.textContent);
		} catch (error) {
			console.error('Error parsing product JSON:', error);
			return;
		}
		
		// Mark as initialized
		variantSelect.setAttribute('data-initialized', 'true');
		
		// Find currently selected color
		const selectedColorInput = variantSelect.querySelector(".product-form__input[data-option-name='Color'] input[type='radio']:checked, .product-form__input[data-option-name='צבע'] input[type='radio']:checked");
		
		if (selectedColorInput) {
			const selectedColor = selectedColorInput.value;
			updateVariantInputs(variantSelect, selectedColor, productData);
		} else {
			// Use first available color if none selected
			const firstColorInput = variantSelect.querySelector(".product-form__input[data-option-name='Color'] input[type='radio'], .product-form__input[data-option-name='צבע'] input[type='radio']");
			
			if (firstColorInput) {
				const firstColor = firstColorInput.value;
				updateVariantInputs(variantSelect, firstColor, productData);
			}
		}
		
		// Add event listeners for color changes
		const colorInputs = variantSelect.querySelectorAll(".product-form__input[data-option-name='Color'] input[type='radio'], .product-form__input[data-option-name='צבע'] input[type='radio']");
		colorInputs.forEach(input => {
			// Remove existing listeners to prevent duplicates
			input.removeEventListener('change', input._colorChangeHandler);
			
			// Create new handler
			input._colorChangeHandler = function() {
				if (this.checked) {
					updateVariantInputs(variantSelect, this.value, productData);
					// Update slider images for this product
					const productCard = variantSelect.closest('.product-card');
					if (productCard) {
						const slider = productCard.querySelector('.product-card-slider');
						if (slider && productData.colors && productData.colors[this.value]) {
							updateSliderImages(slider, productId, productData);
						}
					}
				}
			};
			
			input.addEventListener('change', input._colorChangeHandler);
		});
		
		// Add event listeners for size changes
		const sizeInputs = variantSelect.querySelectorAll(".product-form__input[data-option-name='Size'] input[type='radio'], .product-form__input[data-option-name='גודל'] input[type='radio']");
		sizeInputs.forEach(input => {
			// Remove existing listeners to prevent duplicates
			input.removeEventListener('change', input._sizeChangeHandler);
			
			// Create size change handler
			input._sizeChangeHandler = function() {
				// The global change event listener will handle the rest
			};
			
			input.addEventListener('change', input._sizeChangeHandler);
		});
	});
}

function updateVariantInputs(variantSelects, selectedColor, productData) {
  if (!productData || !productData.variants) {
    return;
  }
  
  if (!selectedColor) {
    return;
  }
  
  const sizeOptions = variantSelects.querySelectorAll(
    ".product-form__input[data-option-name='Size'] input[type='radio'], .product-form__input[data-option-name='גודל'] input[type='radio']"
  );
  
  sizeOptions.forEach((input) => {
    const size = input.value;
    
    // Use unified field naming: opt1/opt2
    const variant = productData.variants.find(v => v.opt1 === selectedColor && v.opt2 === size);
    
    // Use stock field to determine availability
    const available = Boolean(variant?.stock && variant.stock > 0);

    input.disabled = !available;
    input.checked = false;

    // берём первый связанный label
    const label = input.labels && input.labels[0];
    if (!label) return;

    // переключаем класс и атрибут data-sold-out
    label.classList.toggle("disabled", !available);

    if (available) {
      label.removeAttribute("data-sold-out");
      label.setAttribute("title", label.dataset.addToCart || "Add to Cart");
    } else {
      label.setAttribute("data-sold-out", "אזל מהמלאי");
      label.setAttribute("title", label.dataset.soldOut || "Sold Out");
    }
  });
}

// Function to update inventory display when size changes
function updateInventoryDisplay(variantSelects, variant, productId) {
  if (!variant) return;
  
  const productInfo = variantSelects.closest("product-info");
  if (!productInfo) return;
  
  const sectionId = productInfo.getAttribute("data-section");
  const inventoryElement = document.getElementById(`Inventory-${sectionId}`);
  
  if (!inventoryElement) return;
  
  const inventoryQuantity = variant.inventory_quantity || 0;
  const inventoryManagement = variant.inventory_management;
  const inventoryPolicy = variant.inventory_policy;
  
  // Clear existing content
  inventoryElement.innerHTML = '';
  
  if (inventoryManagement === 'shopify') {
    if (inventoryQuantity > 0) {
      // Check if low stock (threshold of 10)
      const isLowStock = inventoryQuantity <= 10;
      
      const iconWrapper = document.createElement('span');
      iconWrapper.className = 'svg-wrapper';
      iconWrapper.style.color = isLowStock ? 'rgb(238, 148, 65)' : 'rgb(62, 214, 96)';
      iconWrapper.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm-1-9h2v6H7V5zm0 8h2v2H7v-2z"/></svg>';
      
      const text = document.createTextNode(
        isLowStock 
          ? `Low stock: ${inventoryQuantity} left`
          : `In stock: ${inventoryQuantity} available`
      );
      
      inventoryElement.appendChild(iconWrapper);
      inventoryElement.appendChild(text);
    } else {
      // Out of stock
      const iconWrapper = document.createElement('span');
      iconWrapper.className = 'svg-wrapper';
      iconWrapper.style.color = inventoryPolicy === 'continue' ? 'rgb(62, 214, 96)' : 'rgb(200, 200, 200)';
      iconWrapper.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm-1-9h2v6H7V5zm0 8h2v2H7v-2z"/></svg>';
      
      const text = document.createTextNode(
        inventoryPolicy === 'continue' 
          ? 'Out of stock - continue selling'
          : 'Out of stock'
      );
      
      inventoryElement.appendChild(iconWrapper);
      inventoryElement.appendChild(text);
    }
  }
}


// Global cache for preloaded images
window.preloadedImages = window.preloadedImages || {};

// Preload the images of one colour of a product. Resolves once the first image
// is in cache - that is the only one the slider shows immediately, so waiting on
// the rest just delays the swap.
function preloadProductImages(productId, productData, color) {
	const colorImages = productData.colors && productData.colors[color] && productData.colors[color].images;
	if (!colorImages || colorImages.length === 0) return Promise.resolve();

	let firstImageReady = Promise.resolve();

	colorImages.forEach((imageSrc, index) => {
		const fullImageUrl = buildOptimizedImageUrl(imageSrc);
		const cacheKey = `${productId}_${color}_${imageSrc}`;

		if (window.preloadedImages[cacheKey]) {
			return;
		}

		const preloadPromise = new Promise((resolve) => {
			const img = new Image();
			img.onload = () => {
				window.preloadedImages[cacheKey] = {
					src: fullImageUrl,
					loaded: true,
					timestamp: Date.now()
				};
				resolve();
			};
			// Resolve on error too - the <img> in the slide has its own fallback handler.
			img.onerror = () => resolve();
			img.src = fullImageUrl;
		});

		if (index === 0) {
			firstImageReady = preloadPromise;
		}
	});

	return firstImageReady;
}



// Export to window for use by infinite scroll
window.initVariantOptions = initVariantOptions;

// Global initialization flag to prevent multiple initializations
window.productPageInitialized = false;

// Global function for color change handling - moved here to be available before stop
window.handleColorChange = function(input) {
	const productId = input.getAttribute('data-product-id');
	const variantId = input.getAttribute('data-variant-id');
	
	if (!productId || !variantId) return;
	
	// Dispatch custom event
	const event = new CustomEvent('variant-change', {
		detail: {
			productId: productId,
			variantId: parseInt(variantId)
		}
	});
	document.dispatchEvent(event);
};

// Use a single DOMContentLoaded listener to prevent conflicts
// Last JS update: 2026-01-25 12:00
if (document.readyState === 'loading') {
	document.addEventListener("DOMContentLoaded", initializeProductPage);
} else {
	initializeProductPage();
}

function initializeProductPage() {
	if (window.productPageInitialized) return;
	
	// Mark as initialized immediately
	window.productPageInitialized = true;
	
	
	// Simple initialization without delays
	initProductSlider();
	observeSliderSlides();
	// Skip variant options init on main product page to avoid disabling sizes on load
	if (!document.querySelector('product-info')) {
		initVariantOptions();
	}
	// Images are preloaded per product when a color is actually picked (see the
	// color selector handler below). Preloading every color of every product on
	// load saturated the connection and starved the visible slider images.
}

// Listen for variant change events
document.addEventListener('variant-change', function(event) {
	// Ignore events originating from PDP main product
	const source = event.target || document;
	const fromProductInfo = !!(source?.closest && source.closest('product-info'));
	if (fromProductInfo) return;
	handleVariantChange(event);
});

	document.addEventListener("change", function (event) {
		const el = event.target;
		
		
		// Check if element matches the main selector
		const matchesMainSelector = el.matches(".product-form__input input[type='radio'], .product-form__input select");
		if (!matchesMainSelector) {
			return;
		}

		const variantSelects = el.closest("variant-selects");
			if (!variantSelects) return;
			
			// SAFEGUARD: ignore PDP main product to avoid interfering with product-info.js
			const isInsideProductInfo = !!variantSelects.closest('product-info');
			const isInsideCardsOrRelated = !!variantSelects.closest('product-recommendations, .related-products, quick-order-list, .product-card, .card-wrapper');
			if (isInsideProductInfo && !isInsideCardsOrRelated) return;
		
		const productId = variantSelects.getAttribute("data-product-id");
		if (!productId) return;

		// Check for product variants data div
		const productVariantsDiv = document.querySelector(`.product-variants-data[data-product-id='${productId}']`);
		if (!productVariantsDiv) return;

		let productData;
		try {
			productData = JSON.parse(productVariantsDiv.textContent);
		} catch (error) {
			return;
		}

		if (!productData.variants) return;

		// Check color selector match
		const isColorSelector = el.matches(".product-form__input[data-option-name='Color'] input[type='radio'], .product-form__input[data-option-name='צבע'] input[type='radio']");
		const isSizeSelector = el.matches(".product-form__input[data-option-name='Size'] input[type='radio'], .product-form__input[data-option-name='גודל'] input[type='radio']");
		
		
		
		if (isColorSelector) {
			// Preload images for the selected color before updating
			const selectedColor = el.value;
			if (productData.colors && productData.colors[selectedColor]) {
				preloadProductImages(productId, productData, selectedColor).then(() => {
					// A newer colour may have been picked while this preload was in
					// flight; applying it now would overwrite the active selection.
					if (!el.checked) return;

					// First image is in cache, now update the slider
					updateVariantInputs(variantSelects, el.value, productData);

					// Trigger variant-change event to update slider images
					triggerVariantChangeEvent(variantSelects, productId, productData);
				});
			} else {
				// No color data, proceed normally
				updateVariantInputs(variantSelects, el.value, productData);
				triggerVariantChangeEvent(variantSelects, productId, productData);
			}
			
			// Skip the rest of the processing for color changes to prevent duplicate handling
			return;
		}

		// Cache selector to avoid repeated DOM queries
		const variantInputs = variantSelects.querySelectorAll(".product-form__input input[type='radio']:checked, .product-form__input select");
		const selectedValues = Array.from(variantInputs).map((input) => input.value);

		const matchedVariant = productData.variants.find((variant) =>
			selectedValues.every((val, index) => {
				// Use unified field naming: opt1/opt2
				const optKey = `opt${index + 1}`;
				return variant[optKey] && variant[optKey] === val;

			})
		);

		if (!matchedVariant) return;

		const { id: variantId } = matchedVariant;
		// Use stock field to determine availability
		const available = Boolean(matchedVariant.stock && matchedVariant.stock > 0);


		const productForm = document.querySelector(`product-form[data-product-form='${productId}']`);
		
		if (productForm) {
			const form = productForm.querySelector('form');
			if (form) {
				const variantInput = form.querySelector(".product-variant-id");
				variantInput?.setAttribute("value", variantId);
				
				const btn = form.querySelector("button");
				const text = btn.querySelector("span:first-child");
				const sold = btn.querySelector(".sold-out-message");
				btn.disabled = !available;
				text.classList.toggle("hidden", !available);
				sold.classList.toggle("hidden", available);

		// Update inventory display when size changes
		if (isSizeSelector) {
			updateInventoryDisplay(variantSelects, matchedVariant, productId);
		}

		// Size selection - automatic add to cart
		if (available && isSizeSelector) {
					
					// Show preloader in the clicked size element
					const sizeLabel = document.querySelector(`label[for="${el.id}"]`);
					let hideBlockPreloader = null;
					
					if (sizeLabel && window.activatePreloaderInBlock) {
						// Create a unique selector for this label
						const labelId = sizeLabel.id || `size-label-${Date.now()}`;
						if (!sizeLabel.id) {
							sizeLabel.id = labelId;
						}
						hideBlockPreloader = window.activatePreloaderInBlock(`#${labelId}`);
					}
					
					const label = document.querySelector(`label[for="${el.id}"]`);
					if (label) {
						const obs = new MutationObserver((mutations, obsrvr) => {
							if (!btn.disabled) {
								label.classList.remove("adding");
								obsrvr.disconnect();
								
								// Hide block preloader
								if (hideBlockPreloader) {
									hideBlockPreloader();
								}
							} else {
								label.classList.add("adding");
							}
						});
						obs.observe(btn, { attributes: true });
						
						// Use requestAnimationFrame for better performance
						requestAnimationFrame(() => {
							btn.click();
						});
					}
					
					// Size change no longer triggers slider image updates
				}
			}
		}

		const priceBlock = variantSelects.closest(".product")?.querySelector(".price__container");
		if (priceBlock) {
			const priceWrap = priceBlock.parentElement;
			const reg = priceBlock.querySelector(".price__regular .price-item--regular");
			const sale = priceBlock.querySelector(".price__sale");
			const saleVal = sale?.querySelector(".price-item--sale");
			const compareVal = sale?.querySelector("s.price-item--regular");

			const showSale = !!compare_at_price;
			
			// Batch DOM updates to prevent forced reflow
			requestAnimationFrame(() => {
				priceWrap.classList.toggle("price--on-sale", showSale);
				priceBlock.querySelector(".price__regular")?.classList.toggle("hidden", showSale);
				sale?.classList.toggle("hidden", !showSale);

				if (showSale) {
					compareVal.textContent = formatMoney(compare_at_price);
					saleVal.textContent = formatMoney(price);
				} else {
					reg.textContent = formatMoney(price);
				}
			});
		}

		const variantScript = document.querySelector(`script[data-variation-id='${variantId}']`);

		if (variantScript) {
			try {
				const extraImgs = JSON.parse(variantScript.textContent);
				variantImgs = [...variantImgs, ...extraImgs];
			} catch (err) {
				console.error("Error parsing variant image JSON:", err);
			}
		}

		// TEMPORARILY DISABLED - causing conflicts
		// const slider = document.querySelector(`.product-card-slider-${productId}`);
		// if (slider) {
		// 	const track = slider.querySelector(".glide__track .glide__slides");
		// 	if (slider.glideInstance) slider.glideInstance.destroy();
		// 	track.innerHTML = "";
		// 	variantImgs.filter(Boolean).forEach((src) => {
		// 		const slide = document.createElement("div");
		// 		slide.className = "glide__slide";
		// 		slide.innerHTML = `<img src="${src}" width="100%" height="auto">`;
		// 		track.appendChild(slide);
		// 	});
		// 	createSlider(slider);
		// }
	});

	// DEBUG: MutationObserver disabled for testing

	// OPTIMIZATION: Caches are now global variables declared at the top of the file
	
	// OPTIMIZATION: Fast AJAX function with caching
	async function getProductData(productHandle) {
		const startTime = performance.now();
		
		if (window.productCache.has(productHandle)) {
			const endTime = performance.now();
			return window.productCache.get(productHandle);
		}
		
		try {
			const response = await fetch(`/products/${productHandle}.js`);
			const productData = await response.json();
			const endTime = performance.now();
			window.productCache.set(productHandle, productData);
			return productData;
		} catch (error) {
			const endTime = performance.now();
			console.error('[AJAX] Error fetching product data:', error, `(${Math.round(endTime - startTime)}ms)`);
			return null;
		}
	}
	
	// Handle variant change for slider images
	function handleVariantChange(event) {
		
		const variantId = event.detail.variantId;
		const productId = event.detail.productId;
		const slider = document.querySelector(`.product-card-slider-${productId}`);
		
		if (!slider) {
			return;
		}
		
		// Get variants data from DOM
		const variantsData = document.querySelector(`.product-variants-data[data-product-id="${productId}"]`);
		const colorImagesData = document.querySelector(`.product-color-images-data[data-product-id="${productId}"]`);
		
		if (!variantsData || !colorImagesData) {
			return;
		}
		
		try {
			const variantsDataObj = JSON.parse(variantsData.textContent.trim());
			const colorImagesDataObj = JSON.parse(colorImagesData.textContent.trim());
			
			// Find variant
			const selectedVariant = variantsDataObj.variants.find(v => v.id === variantId);
			if (!selectedVariant) {
				return;
			}
			
			// Update slider images with variants data
			const productDataWithVariants = {
				...colorImagesDataObj,
				variants: variantsDataObj.variants
			};
			updateSliderImages(slider, productId, productDataWithVariants);
			
		} catch (error) {
			console.error('[VARIANT] Error parsing variants data:', error);
		}
	}
	
	// Prevent double initialization
	let isUpdating = false;
	
	// Common function to trigger variant change event
	function triggerVariantChangeEvent(variantSelects, productId, productData) {
		
		// Cache selector to avoid repeated DOM queries
		const variantInputs = variantSelects.querySelectorAll(".product-form__input input[type='radio']:checked, .product-form__input select");
		const selectedValues = Array.from(variantInputs).map((input) => input.value);
		
		
		const matchedVariant = productData.variants.find((variant) =>
			selectedValues.every((val, index) => {
				const optKey = `opt${index + 1}`;
				return variant[optKey] && variant[optKey] === val;

			})
		);
		
		
		if (matchedVariant) {
			const variantChangeEvent = new CustomEvent('variant-change', {
				detail: {
					variantId: matchedVariant.id,
					productId: productId
				}
			});
			document.dispatchEvent(variantChangeEvent);
		}
	}
	
window.updateSliderImages = function(slider, productId, productData, hideBlockPreloader = null) {
	
	if (isUpdating) {
		return;
	}

	isUpdating = true;
	
	// Store hide function globally for access in updateSliderContent
	window.currentHideBlockPreloader = hideBlockPreloader;

	const slidesContainer = slider.querySelector('.glide__slides');
	if (!slidesContainer) {
		isUpdating = false;
		return;
	}

	// Get selected color from UI - improved search
	const productCard = slider.closest('.product-card') || slider.closest('.card-wrapper') || slider.closest('[data-product-id]') || slider.parentElement;
	
	let colorInput = null;
	if (productCard) {
		// Try multiple selectors for color input
		colorInput = productCard.querySelector('.product-form__input[data-option-name="Color"] input[type="radio"]:checked') ||
					productCard.querySelector('.product-form__input[data-option-name="צבע"] input[type="radio"]:checked') ||
					productCard.querySelector('.product-form__input[data-option-name="color"] input[type="radio"]:checked');
	}
	
	// Fallback: search by productId with multiple selectors
	if (!colorInput) {
		colorInput = document.querySelector(`[data-product-id="${productId}"] .product-form__input[data-option-name="Color"] input[type="radio"]:checked`) ||
					document.querySelector(`[data-product-id="${productId}"] .product-form__input[data-option-name="צבע"] input[type="radio"]:checked`) ||
					document.querySelector(`[data-product-id="${productId}"] .product-form__input[data-option-name="color"] input[type="radio"]:checked`);
	}
	
	const selectedColor = colorInput ? colorInput.value : null;
	
	let imagesToShow = [];

	// Check if we have a selected color
	if (!selectedColor) {
		imagesToShow = productData.images ? productData.images.map(img => img.src) : [];
	} else if (productData.colors && productData.colors[selectedColor] && productData.colors[selectedColor].images) {
		imagesToShow = productData.colors[selectedColor].images;
	} else {
		
		// Fallback to product images if no variant image
		if (productData.images && productData.images.length > 0) {
			const colorImages = productData.images.filter(img => {
				if (img.variant_ids && img.variant_ids.length > 0) {
					return img.variant_ids.some(variantId => {
						const imgVariant = productData.variants.find(v => v.id === variantId);
						return imgVariant && imgVariant.option1 === selectedColor;
					});
				}
				return false;
			});

			if (colorImages.length > 0) {
				imagesToShow = colorImages.map(img => img.src);
			} else {
				// Fallback: use all images if no color-specific images found
				imagesToShow = productData.images.map(img => img.src);
			}
		}
	}
	

	// If no images to show, add fade out effect before clearing
	if (imagesToShow.length === 0) {
		const isRelatedProducts = slider.closest('.related-products') !== null;
		
		if (!isRelatedProducts) {
			// Start fade out effect
			slidesContainer.classList.add('fade-out');
			slidesContainer.classList.remove('fade-in');
			
			// Wait for fade out, then clear content
			setTimeout(() => {
				slidesContainer.innerHTML = '';
				slidesContainer.classList.remove('fade-out');
				
				// Hide block preloader if exists
				if (window.currentHideBlockPreloader) {
					window.currentHideBlockPreloader();
					window.currentHideBlockPreloader = null;
				}
				
				// Reset flag
				isUpdating = false;
			}, 200);
			return;
		}
	}

    // Update slider content with new images and initialize slider after content is loaded
    updateSliderContent(slider, imagesToShow, productId, selectedColor, productData, () => {
        // Always destroy existing slider first
        if (slider.glideInstance) {
            slider.glideInstance.destroy();
            slider.glideInstance = null;
        }
        
        // Initialize slider based on number of images
        if (imagesToShow.length > 1) {
            slider.classList.remove('single-image');
            // Create new slider with updated content
            createSlider(slider);
        } else if (imagesToShow.length === 1) {
            slider.classList.add('single-image');
            // For single image, ensure it's visible and properly styled
            const slidesContainer = slider.querySelector('.glide__slides');
            if (slidesContainer) {
                slidesContainer.style.opacity = '1';
            }
        } else {
            // No images - keep single-image class but ensure opacity is reset
            slider.classList.add('single-image');
            const slidesContainer = slider.querySelector('.glide__slides');
            if (slidesContainer) {
                slidesContainer.style.opacity = '1';
            }
        }
    });

		// Reset flag after completion (don't hide preloader here)
		requestAnimationFrame(() => {
			isUpdating = false;
			// Arrow states are now handled by CSS hover
		});
};

// Function to update slider content with new images
function updateSliderContent(slider, imagesToShow, productId, selectedColor, productData, onComplete = null) {
	const slidesContainer = slider.querySelector('.glide__slides');
	if (!slidesContainer) return;


	// Check if this is "You may also like" block (no fade effect needed)
	const isRelatedProducts = slider.closest('.related-products') !== null;

	if (isRelatedProducts) {
		// For "You may also like" - update immediately without fade effect
		updateContentImmediately();
	} else {
		// For other sliders - use fade effect
		// Start fade out effect
		slidesContainer.classList.add('fade-out');
		slidesContainer.classList.remove('fade-in');

		// Wait for fade out to complete, then update content
		setTimeout(() => {
			updateContentImmediately();
		}, 150); // Match the .fade-out transition in iwebsite-main-product.css
	}

	function updateContentImmediately() {
		// Clear existing slides
		slidesContainer.innerHTML = '';

		// Add slides to DOM with preloaded images optimization
		imagesToShow.forEach((imageSrc, index) => {
			const slide = document.createElement('div');
			slide.className = `glide__slide${index === 0 ? ' is-active' : ''}`;

			// Create link wrapper
			const link = document.createElement('a');
			link.href = getProductUrlWithVariant(productId, selectedColor, productData);
			link.className = 'bdgs_indexed bdgs_badge_itm_par_6595e2211eb3db001644a8c3 bdgs_badge_itm_par_6595e2211eb3db001644a8c3_' + productId;

			const img = document.createElement('img');
			
			// OPTIMIZATION: Use preloaded images if available
			const cacheKey = `${productId}_${selectedColor}_${imageSrc}`;
			const preloadedImage = window.preloadedImages[cacheKey];
			
			// Set fallback handler once
			img.onerror = () => {
				if (!img.dataset.fallbackTried) {
					img.dataset.fallbackTried = '1';
					// Try products folder as a fallback
					img.src = buildOptimizedImageUrlForFolder(imageSrc, 'products');
				}
			};
			
			// The card is on screen and the shopper just picked this colour, so load
			// every slide now - waiting would leave the arrows showing empty slides.
			if (preloadedImage && preloadedImage.loaded) {
				img.src = preloadedImage.src;
			} else {
				img.src = buildOptimizedImageUrl(imageSrc);
			}
			
			img.alt = 'Product image';
			img.style.width = '100%';
			img.style.height = 'auto';
			img.style.display = 'block';
			img.style.maxWidth = '100%';
			img.style.objectFit = 'cover';

			link.appendChild(img);
			slide.appendChild(link);
			slidesContainer.appendChild(slide);
		});
		

		// Height comes from the slides' aspect-ratio in CSS, so there is nothing to
		// pin here - forcing the pre-swap height would fight it.

		// Start fade in effect only for non-related products
		if (!isRelatedProducts) {
			slidesContainer.classList.remove('fade-out');
			slidesContainer.classList.add('fade-in');
		}

		// Hide block preloader if exists
		if (window.currentHideBlockPreloader) {
			window.currentHideBlockPreloader();
			window.currentHideBlockPreloader = null;
		}

		// Call completion callback if provided
		if (onComplete && typeof onComplete === 'function') {
			onComplete();
		}
	}
}

// Helper: build optimized image URL for a specific CDN folder ('files' or 'products')
function buildOptimizedImageUrlForFolder(imageSrc, folder) {
	// If already full URL, add optimization parameters
	if (imageSrc.startsWith('http') || imageSrc.startsWith('//')) {
		const separator = imageSrc.includes('?') ? '&' : '?';
		return `${imageSrc}${separator}width=500&height=auto&quality=80`;
	}
	const domain = window.location.hostname;
	const protocol = window.location.protocol;
	return `${protocol}//${domain}/cdn/shop/${folder}/${imageSrc}?width=500&height=auto&quality=80`;
}


// Function to build full image URL
function buildFullImageUrl(imageSrc) {
	// If already full URL, add optimization parameters
	if (imageSrc.startsWith('http') || imageSrc.startsWith('//')) {
		// Check if URL already has query parameters
		const separator = imageSrc.includes('?') ? '&' : '?';
		return `${imageSrc}${separator}width=500&height=auto&quality=80`;
	}
	
	// Get domain from current page
	const domain = window.location.hostname;
	const protocol = window.location.protocol;
	
	// Build optimized URL with size parameters for faster loading
	// Using Shopify's image transformation API: ?width=500&height=auto&quality=80
	const optimizedUrl = `${protocol}//${domain}/cdn/shop/files/${imageSrc}?width=500&height=auto&quality=80`;
	
	return optimizedUrl;
}

// Function to get product URL with variant ID
function getProductUrlWithVariant(productId, selectedColor, productData) {
	// Get base product URL from existing link - find any product link in the same card
	const cardContainer = document.querySelector(`[data-product-id="${productId}"]`);
	let existingLink = null;
	
	if (cardContainer) {
		// Look for any product link in the card
		existingLink = cardContainer.querySelector('a[href*="/products/"]');
	}
	
	// Fallback: try to find by product ID in any link
	if (!existingLink) {
		existingLink = document.querySelector(`a[href*="/products/"][href*="${productId}"]`);
	}
	
	if (!existingLink) {
		return `/products/${productId}`;
	}
	
	// Get the full URL from existing link (this should have the correct handle)
	let baseUrl = existingLink.href;
	
	// Remove existing variant parameter if it exists
	if (baseUrl.includes('?variant=')) {
		baseUrl = baseUrl.split('?variant=')[0];
	}
	
	// Remove any other query parameters
	if (baseUrl.includes('?')) {
		baseUrl = baseUrl.split('?')[0];
	}
	
	// Find first available variant ID for selected color
	if (productData && productData.variants && selectedColor) {
		// Find all variants with selected color
		const colorVariants = productData.variants.filter(v => v.opt1 === selectedColor);
		
		// Find first available variant (with stock > 0)
		const availableVariant = colorVariants.find(v => v.stock && v.stock > 0);
		
		// If no available variant, use first variant of that color
		const variantToUse = availableVariant || colorVariants[0];
		
		if (variantToUse && variantToUse.id) {
			return `${baseUrl}?variant=${variantToUse.id}`;
		}
	}
	
	return baseUrl;
}

// Function to build optimized image URL with size parameters
function buildOptimizedImageUrl(imageSrc) {
	// Default to 'files' folder; fallback handled via onerror where needed
	return buildOptimizedImageUrlForFolder(imageSrc, 'files');
}

// DEBUG: Disable MutationObserver for testing

// OPTIMIZATION: Cleanup function for memory management
window.cleanupSliderCache = function() {
	if (window.sliderInstanceCache) window.sliderInstanceCache.clear();
	if (window.debounceTimers) window.debounceTimers.clear();
	if (window.productCache) window.productCache.clear();
	if (window.imageCache) window.imageCache.clear();
};

// OPTIMIZATION: Cleanup on page unload
window.addEventListener('beforeunload', function() {
	window.cleanupSliderCache();
});
